export type AccountType = 'ASSET' | 'LIABILITY' | 'EQUITY' | 'REVENUE' | 'EXPENSE';

export interface ChartAccount {
  code: string;
  name: string;
  type: AccountType;
  parentCode?: string;
}

/** Mirrors server/src/lib/accounting/chartOfAccounts.ts SEED — docs stay in sync with the ledger. */
export const CHART_OF_ACCOUNTS: ChartAccount[] = [
  { code: '1000', name: 'Cash on hand', type: 'ASSET' },
  { code: '1010', name: 'Bank', type: 'ASSET' },
  { code: '1200', name: 'Inventory', type: 'ASSET' },
  { code: '1300', name: 'Accounts receivable', type: 'ASSET' },
  { code: '2000', name: 'Accounts payable', type: 'LIABILITY' },
  { code: '2100', name: 'VAT payable', type: 'LIABILITY' },
  { code: '3000', name: "Owner's equity", type: 'EQUITY' },
  { code: '3100', name: 'Retained earnings', type: 'EQUITY' },
  { code: '3200', name: 'Cash short/over', type: 'EQUITY' },
  { code: '4000', name: 'Sales revenue', type: 'REVENUE' },
  { code: '5000', name: 'Cost of goods sold', type: 'EXPENSE' },
  { code: '6000', name: 'Operating expenses', type: 'EXPENSE' },
  { code: '6100', name: 'Rent', type: 'EXPENSE', parentCode: '6000' },
  { code: '6200', name: 'Fuel / transport', type: 'EXPENSE', parentCode: '6000' },
  { code: '6300', name: 'Salaries', type: 'EXPENSE', parentCode: '6000' },
  { code: '6400', name: 'Utilities', type: 'EXPENSE', parentCode: '6000' },
  { code: '6500', name: 'Maintenance', type: 'EXPENSE', parentCode: '6000' },
  { code: '6600', name: 'Marketing', type: 'EXPENSE', parentCode: '6000' },
  { code: '6700', name: 'Equipment', type: 'EXPENSE', parentCode: '6000' },
  { code: '6800', name: 'Supplies', type: 'EXPENSE', parentCode: '6000' },
  { code: '6850', name: 'Insurance', type: 'EXPENSE', parentCode: '6000' },
  { code: '6860', name: 'Professional fees', type: 'EXPENSE', parentCode: '6000' },
  { code: '6900', name: 'Other / uncategorised', type: 'EXPENSE', parentCode: '6000' },
];

export const ACCOUNT_TYPE_ORDER: AccountType[] = ['ASSET', 'LIABILITY', 'EQUITY', 'REVENUE', 'EXPENSE'];

export const ACCOUNT_TYPE_LABEL: Record<AccountType, string> = {
  ASSET: 'Assets',
  LIABILITY: 'Liabilities',
  EQUITY: 'Equity',
  REVENUE: 'Revenue',
  EXPENSE: 'Expenses',
};

export interface HelpArticle {
  slug: string;
  title: string;
  summary: string;
}

export const HELP_ARTICLES: HelpArticle[] = [
  {
    slug: 'getting-started',
    title: 'Getting started',
    summary: 'Create your business, add products, open POS, and ring your first sale.',
  },
  {
    slug: 'accounting',
    title: 'How cevop books your money',
    summary: 'The default chart of accounts, and what happens when you sell, spend, or close a POS session.',
  },
  {
    slug: 'tax',
    title: 'Tax at the register',
    summary: 'Exclusive vs inclusive pricing, VAT on counter sales, and what cashiers see.',
  },
  {
    slug: 'pos',
    title: 'POS',
    summary: 'Opening float, expected cash, counted cash, and short/over.',
  },
  {
    slug: 'security',
    title: 'Security & data',
    summary: 'How we protect your account, isolate tenants, and handle sensitive actions.',
  },
];
